import React from "react";
import PersonalData from "../PersonalData";
import PersonalDataContextProvider, {
  PersonalDataContext,
  ACTIONS,
} from "./../../context/PersonalDataContextProvider";
import Loading from "../../../../common/components/Loading";

function ControllerPersonalData({ props }) {
  const [state, dispatch] = React.useContext(PersonalDataContext);
  const [values, setValues] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [checkBox, setCheckBox] = React.useState(false);
  const [jsonForm, setJsonForm] = React.useState();
  const [userAttributes, setUserAttributes] = React.useState({});
  const [idRegion, setIdRegion] = React.useState("");
  const [optionsRegion, setOptionsRegion] = React.useState([]);
  const [optionsComunaRegion, setOptionsComunaRegion] = React.useState([]);
  const [optionsPrefixCell, setOptionsPrefixCell] = React.useState([]);
  const objProp = {
    values,
    setValues,
    checkBox,
    setCheckBox,
    jsonForm,
    setJsonForm,
    setUserAttributes,
    userAttributes,
    optionsComunaRegion,
    setIdRegion,
    optionsRegion,
    optionsPrefixCell,
    setOptionsPrefixCell,
  };

  React.useEffect(() => {
    setLoading(true);

    if (props?.list_DDD_cellphone) {
      const auxStr = props?.list_DDD_cellphone.replaceAll("[", "").replaceAll("]", "");
      const auxAr = auxStr.split(",");
      let auxAr2 = [];
      auxAr.map((obj) => {
        auxAr2.push({ label: obj, value: obj });
      });
      setOptionsPrefixCell(auxAr2);
    }
  }, []);

  React.useEffect(() => {
    if (state.userAttributes) {
      let auxPrefix = "";
      let house_phone_number = "";

      if (state.userAttributes["custom:house_phone_number"]?.substr(0, 1) === "2") {
        house_phone_number = state.userAttributes["custom:house_phone_number"]?.substr(1, 8);
        auxPrefix = 2;
      } else if (state.userAttributes["custom:house_phone_number"]) {
        house_phone_number = state.userAttributes["custom:house_phone_number"]?.substr(2, 8);
        auxPrefix = state.userAttributes["custom:house_phone_number"]?.substr(0, 2);
      }

      const objUserAttributes = {
        name: state.userAttributes?.given_name,
        paternalSurname: state.userAttributes?.family_name,
        maternalSurname: state.userAttributes["custom:second_family_name"],
        street: state.userAttributes["custom:address_street"],
        number: state.userAttributes["custom:address_number"],
        dpto: state.userAttributes["custom:address_building"],
        region: Number(state.userAttributes["custom:address_region"]),
        commune: state.userAttributes["custom:address_commune"],
        telephone: house_phone_number,
        cellPhone: state.userAttributes?.phone_number?.replace("+56", ""),
        email: state.userAttributes?.email,
        confirmEmail: state.userAttributes?.email,
        emailNewsletter:
          Number(state.userAttributes["custom:email_newsletter"]) === 1 ? true : false,
        prefixCell: auxPrefix,
      };

      setCheckBox(objUserAttributes.emailNewsletter);
      setUserAttributes(objUserAttributes);
      setValues(objUserAttributes);
      setLoading(false);
    }
  }, [state.userAttributes]);

  React.useEffect(() => {
    if (jsonForm) {
      setLoading(true);
      dispatch({
        type: ACTIONS.SET_JSON_FORMS,
        payload: jsonForm,
      });
    }
  }, [jsonForm]);

  React.useEffect(() => {
    if (idRegion) {
      setLoading(true);
      dispatch({
        type: ACTIONS.SET_ID_REGION,
        payload: idRegion,
      });
    } else {
      setOptionsComunaRegion([{ label: "Selecione una opción", value: "" }]);
    }
  }, [idRegion]);

  React.useEffect(() => {
    if (state.allRegion && optionsRegion?.length === 0) {
      if (state.allRegion?.code === 0) {
        let regions = [
          {
            label: "Selecione una opción",
            value: "",
          },
        ];

        state.allRegion?.regions.forEach((item) => {
          regions.push({ label: item.nomeRegion, value: item.regionId });
        });

        setOptionsRegion([...optionsRegion, ...regions]);
      } else {
        props.setGlobalAlert(
          state.allRegion?.message ? state.allRegion?.message : props.text_fetch_error,
          "warning",
          true,
          "Advertencia"
        );
      }
    }
  }, [state.allRegion]);

  React.useEffect(() => {
    if (state.comunaRegion) {
      setLoading(false);
      if (state.comunaRegion.code === 0) {
        let comunas = [];
        state.comunaRegion?.comunas.forEach((item) => {
          comunas.push({ label: item.nomComuna, value: item.codigoSAP });
        });
        setOptionsComunaRegion([{ label: "Selecione una opción", value: "" }, ...comunas]);
      } else {
        props.setGlobalAlert(
          state.comunaRegion?.message ? state.comunaRegion?.message : props.text_fetch_error,
          "warning",
          true,
          "Advertencia"
        );
      }
    }
  }, [state.comunaRegion]);

  React.useEffect(() => {
    setLoading(false);
    if (state.responsePostUserAttributes) {
      if (state.responsePostUserAttributes?.data?.ok) {
        props.setGlobalAlert(
          state.responsePostUserAttributes?.data?.message
            ? state.responsePostUserAttributes?.data?.message
            : "¡Datos modificados con éxito!",
          "success",
          true,
          "Confirmacíon"
        );
      } else {
        props.setGlobalAlert(
          state.responsePostUserAttributes?.data?.message
            ? state.responsePostUserAttributes?.data?.message
            : props.text_fetch_error,
          "warning",
          true,
          "Advertencia"
        );
      }
    }
  }, [state.responsePostUserAttributes]);

  return (
    <div id="PersonalData">
      <PersonalData props={{ ...props,...objProp }} />
      {loading && <Loading />}
    </div>
  );
}

const ControllerPersonalDataWithProvider = ({ props }) => (
  <PersonalDataContextProvider>
    <ControllerPersonalData props={props} />
  </PersonalDataContextProvider>
);
export default ControllerPersonalDataWithProvider;
